export default __webpack_public_path__ + "static/media/702.2fa7d297.png";